import React, { useEffect, useState, lazy, Suspense } from "react";
import { Spin } from "antd";

const TournamentListDesktop = lazy(() => import("./tournament-desktop"));
const TournamentListMobile = lazy(() => import("./tournament-mobile"));

const TournamentList = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateLayout = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 900);
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  return (
    <Suspense fallback={<Spin fullscreen size="large" tip="Đang tải giao diện..." />}>
      {isMobile ? <TournamentListMobile /> : <TournamentListDesktop />}
    </Suspense>
  );
};

export default TournamentList;